module.exports = __webpack_public_path__ + "img/23.1d1b7281.png";